<div class="header-container">
  <h1 class="header-title">API</h1>
</div>
<div class="content">
  <div class="statistics">
    <div class="statistic-item">
      <nz-skeleton *ngIf="!chartOptions" [nzActive]="true"></nz-skeleton>
      <div class="statistic-item-content" *ngIf="chartOptions">
        <h2>Data API Calls</h2>
        <div class="chart-type-toggle">
          <button nz-button [nzType]="chartType === 'heatmap' ? 'primary' : 'default'" (click)="setChartType('heatmap')">Heatmap</button>
          <button nz-button [nzType]="chartType === 'bar' ? 'primary' : 'default'" (click)="setChartType('bar')">Stacked bar</button>
          <nz-range-picker
            nzFormat="dd.MM.yyyy"
            [ngModel]="dateRange"
            (ngModelChange)="onDateRangeChange($event)">
          </nz-range-picker>
        </div>
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [plotOptions]="chartOptions.plotOptions"
          [dataLabels]="chartOptions.dataLabels"
          [title]="chartOptions.title"
          [yaxis]="chartOptions.yaxis"
          [tooltip]="chartOptions.tooltip">
        </apx-chart>
      </div>
    </div>
  </div>
</div>
